import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import { get } from "lodash";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

import TopBarMenu from "./TopBarMenu";
import Breadcrumb from "./Breadcrumb/Breadcrumb";
import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  topbarContainer: {
    height: "50px",
    boxShadow: `0px 2px 2px 0px ${colors.black23}`,
  },
  coloredLine: {
    height: "3px",
    background: `linear-gradient(to right, ${colors.primary}, ${colors.white})`,
  },
  topbar: {
    backgroundColor: colors.white,
    height: "47px",
    lineHeight: "47px",

    '@media(max-width: 470px)': {
      display: "flex",
      justifyContent: "space-between",
    }
  },
  logoContainer: {
    height: "33px",
    lineHeight: "13px",
    borderRight: `1px solid ${colors.veryLighPink}`,
    margin: "7px",
  },
  breadcrumb: {
    paddingLeft: "20px",
    height: "44px",
  },
  dropDownMenu: {
    height: "44px",
    paddingRight: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  name: {
    fontSize: "1em",
    color: colors.black87,
    lineHeight: "30px",
  },
  bottomArrow: {
    marginBottom: "2px",
    marginLeft: "5px",
  },
  companyLogoContainer: {
    height: "44px",
    marginBottom: "3px",
    marginRight: "20px",
    display: "flex",
    alignItems: "center",
    "& img": {
      height: "30px",
    },
  },

  topBarResponsive: {
    '@media(max-width: 470px)': {
      display: "none",
    }
  }
};

const TopBar = (props) => {
  const { classes, user } = props;

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  return (
    <Grid container direction="column" className={classes.topbarContainer}>
      <Grid item className={classes.coloredLine} />
      <Grid item>
        <Grid container className={classes.topbar}>
          <Grid
            item
            className={clsx("flex-full-center", classes.logoContainer)}
          >
            <Link to="/">
              <img src={getWidth() > 470 ? images.lukeLogo : images.jrvLogo} height="31px" alt="luke" />
            </Link>
          </Grid>
          <Grid item xs className={`${classes.breadcrumb} ${classes.topBarResponsive}`}>
            <Breadcrumb breadcrumb={props.breadcrumb} />
          </Grid>
          <Grid item className={`${classes.companyLogoContainer} ${classes.topBarResponsive}`}>
            <img id="company_thumbnail"
              src={"/dynamic/theme/logo/thumbnail"}
              alt="company_thumbnail"
              style={{
                height: "55%"
              }}
            />
          </Grid>
          <Grid item className={`${classes.dropDownMenu} ${classes.topBarResponsive}`}>
            <TopBarMenu menu={["aboutLuke"]}>
              <img src={images.topbarInfos} alt="info" />
            </TopBarMenu>
          </Grid>
          <Grid item className={classes.dropDownMenu}>
            <TopBarMenu menu={["myAccount", "logout"]}>
              <Grid item className={classes.name}>
                {`${get(user, ["firstName"])} ${get(user, ["lastName"])}`}
              </Grid>
              <Grid item className="flexCenter">
                <img
                  className={classes.bottomArrow}
                  src={images.bottomArrowLight}
                  alt="bottom_arrow"
                />
              </Grid>
            </TopBarMenu>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    breadcrumb: state.common.breadcrumb,
    user: state.user,
    dynamicThemeThumbNail: get(state, ["homePage", "dynamicThemeThumbNail"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(TopBar));
